import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function LogoutPage() {
    // console.log('logout page called');
    const navigate = useNavigate();
    React.useEffect(() => {
        // Get stored login path before clearing storage
        const loginPath = localStorage.getItem('loginPath') || '/';

        // Clear storage
        sessionStorage.clear();
        localStorage.removeItem('loginPath'); // Remove login path after reading

        // Redirect to stored login path
        navigate(loginPath, { replace: true });
    }, [navigate]);

    return <div>Please wait...</div>;
}
